import * as React from 'react';

import { cn } from '@/shared/lib/utils';

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          // Mirrors the Input premium treatment — soft slate border, white
          // bg, sky focus glow. See `input.tsx` for the rationale on each
          // line (preflight-off + Bootstrap coexistence).
          'tw-flex tw-min-h-[80px] tw-w-full tw-rounded-md tw-text-sm tw-text-foreground',
          // `tw-border-solid` is required: preflight is OFF so UA/Bootstrap
          // default border-style leaks through unless we set it explicitly.
          'tw-border tw-border-solid tw-border-slate-200 tw-bg-white',
          'tw-px-3 tw-py-2 tw-shadow-[0_1px_2px_rgba(0,0,0,0.04)]',
          'tw-transition-[border-color,box-shadow] tw-duration-150 tw-ease-out',
          'placeholder:tw-text-slate-400',
          'hover:tw-border-slate-300',
          'focus-visible:tw-outline-none focus-visible:tw-border-sky-400 focus-visible:tw-ring-4 focus-visible:tw-ring-sky-100',
          'disabled:tw-cursor-not-allowed disabled:tw-bg-slate-50 disabled:tw-text-slate-500 disabled:tw-opacity-100',
          'dark:tw-border-slate-800 dark:tw-bg-slate-950 dark:placeholder:tw-text-slate-500 dark:hover:tw-border-slate-700 dark:focus-visible:tw-border-sky-500 dark:focus-visible:tw-ring-sky-900/30',
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Textarea.displayName = 'Textarea';

export { Textarea };
